import React from 'react';
import { useGlobalPermission } from '@/hooks/useGlobalPermission';

interface SectionPermissionWrapperProps {
  permission: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const SectionPermissionWrapper: React.FC<SectionPermissionWrapperProps> = ({ 
  permission, 
  children, 
  fallback = null 
}) => {
  const hasPermission = useGlobalPermission();

  if (!hasPermission(permission)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};